export default function ContactInfo() {
  return (
    <section className="py-20 px-6 bg-beige-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-amber-600 text-sm font-medium tracking-wider uppercase mb-3">Reach Us</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Contact <strong>Information</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Multiple ways to reach our team. We're here to help with all your <strong>painting and decorating</strong> needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-beige-200">
            <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mb-6 mx-auto">
              <i className="ri-phone-line text-3xl text-amber-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">Phone</h3>
            <p className="text-sm text-gray-600 mb-4 text-center">
              Call us for immediate assistance and free quotes
            </p>
            <div className="text-center">
              <a
                href="tel:07595037441"
                className="text-lg font-semibold text-amber-600 hover:text-amber-700 transition-colors cursor-pointer"
              >
                07595037441
              </a>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-beige-200">
            <div className="w-16 h-16 flex items-center justify-center bg-sky-100 rounded-full mb-6 mx-auto">
              <i className="ri-mail-line text-3xl text-sky-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">Email</h3>
            <p className="text-sm text-gray-600 mb-4 text-center">
              Send us your project details and we'll respond within 24 hours
            </p>
            <div className="text-center">
              <a
                href="mailto:daniel@brushour.co.uk"
                className="text-lg font-semibold text-sky-600 hover:text-sky-700 transition-colors cursor-pointer"
              >
                daniel@brushour.co.uk
              </a>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-beige-200">
            <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mb-6 mx-auto">
              <i className="ri-map-pin-line text-3xl text-amber-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">Service Area</h3>
            <p className="text-sm text-gray-600 mb-4 text-center">
              Proudly serving <strong>Hertfordshire</strong> and surrounding areas
            </p>
            <div className="text-center">
              <p className="text-lg font-semibold text-gray-800">
                Watford, Hertfordshire
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-white p-8 rounded-lg shadow-sm border border-beige-200">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">Business Hours</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            <div className="flex justify-between items-center py-3 border-b border-beige-200">
              <span className="text-sm font-semibold text-gray-800">Monday - Friday</span>
              <span className="text-sm text-sky-600 font-medium">8:00 AM - 6:00 PM</span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-beige-200">
              <span className="text-sm font-semibold text-gray-800">Saturday</span>
              <span className="text-sm text-sky-600 font-medium">9:00 AM - 4:00 PM</span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-beige-200">
              <span className="text-sm font-semibold text-gray-800">Sunday</span>
              <span className="text-sm text-gray-600">Closed</span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-beige-200">
              <span className="text-sm font-semibold text-gray-800">Emergency Service</span>
              <span className="text-sm text-amber-600 font-medium">Available</span>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <h3 className="text-2xl font-bold text-gray-800 mb-6">Connect on Social Media</h3>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="https://www.facebook.com/brushour"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-sky-600 hover:bg-sky-700 text-white rounded-full transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-facebook-fill text-xl"></i>
            </a>
            <a
              href="https://www.instagram.com/brushour_"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-amber-500 hover:bg-amber-600 text-white rounded-full transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a
              href="https://www.tiktok.com/@brushour_"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-gray-800 hover:bg-gray-900 text-white rounded-full transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-tiktok-line text-xl"></i>
            </a>
            <a
              href="https://www.youtube.com/@brushour"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-red-600 hover:bg-red-700 text-white rounded-full transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-youtube-fill text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
